import React from "react";
import useContainerEffect from "../../core/hooks/useContainerEffect";
import "../container_effects.css";

/**
 * Transparent overlay that renders a container effect on top of existing content.
 * Place this as a sibling to the Background component inside a `position: relative`
 * parent. The overlay is fully non-interactive (pointer-events: none).
 *
 * @param {{ data: Object }} props - Element data with `container_effect` key.
 */
const ContainerEffectOverlay = ({ data }) => {
  const { effectClassName, effectStyle, hasEffect } = useContainerEffect(data);

  if (!hasEffect) return null;

  return (
    <div
      className={`absolute inset-0 z-[5] pointer-events-none rounded-[inherit] overflow-hidden ${effectClassName}`}
      style={effectStyle}
      aria-hidden="true"
    />
  );
};

export default React.memo(ContainerEffectOverlay);
